import { Box, Button } from '@mui/material';
import Typography from '@mui/material/Typography';
import { useNavigate } from 'react-router';
import { useCallback, useEffect, useState } from 'react';
import { Routes } from '@xolv-mybrightlink/common';

export const NotFoundPage = () => {
  const navigate = useNavigate();
  const goHome = useCallback(() => {
    navigate(Routes.authenticated);
  }, [navigate]);

  const [seconds, setSeconds] = useState(5);
  useEffect(() => {
    const interval = setInterval(() => {
      if (seconds === 0) {
        goHome();
      } else {
        setSeconds(seconds - 1);
      }
    }, 1000);
    return () => clearInterval(interval);
  }, [goHome, seconds]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
      }}
    >
      <Typography variant='h4'>Not Found!</Typography>
      <Button variant='contained' sx={{ mt: 2 }} onClick={goHome}>
        <Typography>{`Go to home in ${seconds} second${
          seconds > 1 ? 's' : ''
        }`}</Typography>
      </Button>
    </Box>
  );
};
